<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<path
		d="M13.1254 6C13.1254 5.1712 12.7961 3.37634 12.2101 2.79029C11.624 2.20424 10.8292 1.875 10.0004 1.875C9.17155 1.875 8.3767 2.20424 7.79064 2.79029C7.20459 3.37634 6.87535 5.1712 6.87535 6M16.3387 7.08917L17.3912 17.0892C17.4495 17.6433 17.0162 18.125 16.4587 18.125H3.54202C3.41053 18.1251 3.28047 18.0976 3.16031 18.0442C3.04015 17.9908 2.93256 17.9127 2.84454 17.8151C2.75652 17.7174 2.69003 17.6023 2.6494 17.4772C2.60877 17.3521 2.59489 17.2199 2.60869 17.0892L3.66202 7.08917C3.68632 6.8588 3.79504 6.64558 3.96723 6.49063C4.13942 6.33568 4.36288 6.24996 4.59452 6.25H15.4062C15.8862 6.25 16.2887 6.6125 16.3387 7.08917Z"
		stroke="currentColor"
		stroke-width="1.6"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
</svg>
